// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-ignore
import App from "./App.svelte";
import "./lib/i18n";
const app = new App({
    target: document.body,
    props: {},
    intro: true
});
export default app;
